import { render, staticRenderFns } from "./CardGroupAssociations.vue?vue&type=template&id=aac653da&"
import script from "./CardGroupAssociations.vue?vue&type=script&lang=js&"
export * from "./CardGroupAssociations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports